/* Bambus+ — favoritter (Michael 13/9).
   Hjerte paa produkterne. Ikke logget ind: favoritterne ligger i browseren (localStorage).
   Logget ind: de gemmes paa kundens konto via /apps/klub/favoritter (Shopify app proxy), og det
   der laa i browseren foer login, flettes ind paa kontoen. */
(function () {
  var NOEGLE = 'bambusklubben_favoritter';
  var PROXY = '/apps/klub/favoritter';
  var loggetInd = document.body && document.body.classList.contains('customer-logged-in');
  var favoritter = laes();
  var sidst = null;

  function laes() {
    try { var v = JSON.parse(localStorage.getItem(NOEGLE) || '[]'); return Array.isArray(v) ? v : []; }
    catch (e) { return []; }
  }
  function gem() {
    try { localStorage.setItem(NOEGLE, JSON.stringify(favoritter)); } catch (e) {}
  }
  function er(h) { return favoritter.indexOf(h) !== -1; }

  function tegn() {
    var knapper = document.querySelectorAll('[data-klub-fav]');
    for (var i = 0; i < knapper.length; i++) {
      var k = knapper[i], h = k.getAttribute('data-klub-fav');
      k.setAttribute('aria-pressed', er(h) ? 'true' : 'false');
      k.classList.toggle('klub-hjerte--valgt', er(h));
    }
    var antal = document.querySelectorAll('[data-klub-fav-antal]');
    for (var j = 0; j < antal.length; j++) {
      antal[j].textContent = favoritter.length ? String(favoritter.length) : '';
      antal[j].hidden = !favoritter.length;
    }
    /* Kun naar listen er aendret. Ellers giver sidens egen gentegning en uendelig loekke
       (MutationObserver -> tegn -> haendelse -> siden tegner om -> MutationObserver …). */
    var nu = JSON.stringify(favoritter);
    if (nu !== sidst) { sidst = nu; document.dispatchEvent(new CustomEvent('klub:favoritter', { detail: favoritter.slice() })); }
  }

  function send(krop) {
    if (!loggetInd) return Promise.resolve(null);
    return fetch(PROXY, { method: 'POST', headers: { 'content-type': 'application/json' },
                          body: JSON.stringify(krop), credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  function skift(h) {
    if (er(h)) {
      favoritter = favoritter.filter(function (x) { return x !== h; });
      send({ fjern: h });
    } else {
      favoritter.push(h);
      send({ tilfoej: h });
    }
    gem(); tegn();
  }

  document.addEventListener('click', function (e) {
    var k = e.target.closest && e.target.closest('[data-klub-fav]');
    if (!k) return;
    e.preventDefault(); e.stopPropagation();
    skift(k.getAttribute('data-klub-fav'));
  }, true);

  /* Kort der hentes senere (filtre, "vis flere") faar ogsaa den rigtige tilstand. */
  if (window.MutationObserver) {
    var ventende = null;
    new MutationObserver(function () {
      if (ventende) return;
      ventende = setTimeout(function () { ventende = null; tegn(); }, 150);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  window.KlubFavoritter = {
    alle: function () { return favoritter.slice(); },
    fjern: function (h) { if (er(h)) skift(h); }
  };

  tegn();

  /* Logget ind: hent kontoens liste og flet browserens ind. */
  if (loggetInd) {
    fetch(PROXY, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        if (!d || !Array.isArray(d.favoritter)) return;
        var lokale = favoritter.filter(function (h) { return d.favoritter.indexOf(h) === -1; });
        favoritter = d.favoritter.concat(lokale);
        gem(); tegn();
        if (lokale.length) send({ alle: lokale });
      });
  }
})();
